import React, { useState } from 'react';
import type { MouseEvent } from 'react';
import { Card, CardHeader, CircularProgress, Divider } from '@mui/material';
import { PageHeader } from '../../components/molecules';
import { AdminLayout } from '../../components/templates';
import { labels, PATH } from '../../constants';
import { AgencyListTable } from '../../components/features/agencies/AgencyListTable';
import { AddButton } from '../../components/atoms';
import { applyPagination } from '../../utils/apply-pagination';
import { useAgencies } from '../../hooks';

const rowsPerPage = 20;

export const AgencyListPage = () => {
  const { agencies, isFetching } = useAgencies();

  const [page, setPage] = useState<number>(0);

  const paginatedAgencies = applyPagination(agencies, page, rowsPerPage);

  const handlePageChange = (
    event: MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ): void => {
    setPage(newPage);
  };

  return (
    <AdminLayout>
      <PageHeader
        label={labels.pages.agencies.list}
        button={
          <AddButton label={labels.form.actions.add} to={PATH.AGENCY_ADD} />
        }
      />
      <Card>
        <CardHeader title={labels.pages.agencies.list} />
        <Divider />

        {/* 読み込み中はローディングアイコンを表示 */}
        {isFetching ? (
          <CircularProgress />
        ) : (
          <AgencyListTable
            items={paginatedAgencies}
            itemsCount={agencies.length}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            page={page}
          />
        )}
      </Card>
    </AdminLayout>
  );
};
